var EMAIL_VALIDATION = /^[а-яА-ЯёЁa-zA-Z0-9.+_-]+@[а-яА-ЯёЁa-zA-Z0-9.-]+\.[а-яА-ЯёЁa-zA-Z]{2,30}$/;
export default function validateEmail(value) {
  return EMAIL_VALIDATION.test(value);
}